import superagent from 'superagent';
import * as c from '../constants/actionTypes';
import * as config from '../config/config';

export function ToggleQuestion(index, array) {
  return {
    type: c.TOGGLE_QUESTION,
    index: index,
    array: array
  }
}

export function closeExtraModal(question) {
  return {
    type: c.CLOSE_QUESTION,
    state: false
  }
}



// WEBPACK FOOTER //
// ./src/actions/FAQ.js